module.exports = "\n\n  <header>\n    <nav>\n        <a routerLink=\"/home\">Home</a>\n        <a routerLink=\"/component1\">Component 1</a>\n        <a routerLink=\"/component2\">Component 2</a>\n    </nav>\n  </header>\n\n\n<router-outlet></router-outlet>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main